import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.hamama.kwhi.LocalLayerContainer
import firebase.initFirebaseIfNeeded
import kotlinx.browser.document
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initFirebaseIfNeeded()
    onWasmReady {
        ComposeViewport(viewportContainerId = "components") {
            CompositionLocalProvider(LocalLayerContainer provides document.getElementById("components")!!) {
                App()
            }
        }
    }
}